export default __webpack_public_path__ + "static/media/redActiveUserIcon.d96a8684.svg";